import { TYPES } from "../../envs/core";

export const MODULE_TYPES = {
  RESULTADOS: "Resultados",
  PACTOMETRO: "Pactometro",
  RANKING: "Ranking",
  ARCO: "Arco congreso",
  ARCO_SENADO: "Arco senado",
  BARRAS: "Comparativa de escaños",
  MINI: "Posibles pactos",
  BUTTONS: "Generador de enlaces"
};

export const MODULES_A3 = {
  RESULTADOS: "Resultados",
  PACTOMETRO: "Pactometro",
  ARCO: "Arco congreso",
  ARCO_SENADO: "Arco senado",
  BARRAS: "Comparativa de escaños",
  BUTTONS: "Generador de enlaces"
};

export const MODULES_LASEXTA = {
  RESULTADOS: "Resultados",
  PACTOMETRO: "Pactometro",
  RANKING: "Ranking",
  MINI: "Posibles pactos",
  BUTTONS: "Generador de enlaces"
};

export const MODULES_LOCATION_A3 = {
  RESULTADOS: "Resultados",
  ARCO: "Arco congreso",
  ARCO_SENADO: "Arco senado",
  BUTTONS: "Generador de enlaces"
};

export const MODULES_LOCATION_LASEXTA = {
  RESULTADOS: "Resultados",
  BUTTONS: "Generador de enlaces"
};

export const getElectionName = type => {
  switch (type) {
    case TYPES.GENERAL:
      return "generales";
    case TYPES.REGIONAL:
      return "autonómicas";
    case TYPES.MUNICIPAL:
      return "municipales";
    case TYPES.EUROPEAN:
      return "europeas";
    default:
      throw new Error("Error");
  }
};

export const getModuleAmp = (url, height = 800) =>
  `<amp-iframe 
  width="750" 
  height="${height}" 
  sandbox="allow-popups allow-scripts allow-same-origin" 
  layout="responsive" 
  frameborder="0"
  style="height: ${height}px"
  src="${window.location.href.replace("/generador.html", url)}#amp=1">
    <amp-img 
      placeholder 
      layout="fill"
      src="https://www.antena3.com/public/img/grupo-atresmedia.svg">
    </amp-img>
</amp-iframe>`;

export const getModuleWeb = (moduleId, url) =>
  `<div id="${moduleId}"></div>
  
<script>
var cssId = "myCss"; // you could encode the css path itself to generate id..
var scriptId = "myScript"; // you could encode the css path itself to generate id..
if (!document.getElementById(cssId)) {
  var head = document.getElementsByTagName("head")[0];
  var link = document.createElement("link");
  link.id = cssId;
  link.rel = "stylesheet";
  link.type = "text/css";
  link.href = "/elecciones-2019-2/static/css/main.css";
  link.media = "all";
  head.appendChild(link);

  var script = document.createElement("script");
  script.setAttribute(
    "src",
    "/elecciones-2019-2/static/js/main.js"
  );
  script.id = scriptId;
  script.onload = function() {
    document.dispatchEvent(new CustomEvent("script-load"));

    window.init(document.getElementById('${moduleId}'),"${url}")

  };
  document.body.appendChild(script);
} else {
  document.addEventListener("script-load", function(e) {
    window.init(document.getElementById('${moduleId}'),"${url}")

  });
}
</script>`;
